import { useEffect, useState, useRef, useMemo } from "react";
import { Truck, Save, X, Building2, User, Phone, Mail } from "lucide-react";
import Swal from "sweetalert2";
import api from "../services/api";

export default function SupplierForm({ onSaved, editingSupplier, onCancel }) {
  const nombreRef = useRef(null);

  const [form, setForm] = useState({
    nombre: "",
    nombre_comercial: "",
    contacto: "",
    telefono: "",
    email: "",
    direccion: "",
    departamento: "",
    municipio: "",
    nit: "",
    nrc: "",
    giro: "",
  });

  const [loading, setLoading] = useState(false);

  // ✅ CAT-012 Departamentos
  const departamentos = [
    { codigo: "00", nombre: "Otro (Para extranjeros)" },
    { codigo: "01", nombre: "AHUACHAPAN" },
    { codigo: "02", nombre: "SANTA ANA" },
    { codigo: "03", nombre: "SONSONATE" },
    { codigo: "04", nombre: "CHALATENANGO" },
    { codigo: "05", nombre: "LA LIBERTAD" },
    { codigo: "06", nombre: "SAN SALVADOR" },
    { codigo: "07", nombre: "CUSCATLAN" },
    { codigo: "08", nombre: "LA PAZ" },
    { codigo: "09", nombre: "CABAÑAS" },
    { codigo: "10", nombre: "SAN VICENTE" },
    { codigo: "11", nombre: "USULUTAN" },
    { codigo: "12", nombre: "SAN MIGUEL" },
    { codigo: "13", nombre: "MORAZAN" },
    { codigo: "14", nombre: "LA UNION" },
  ];

  // ✅ CAT-013 Municipios CON RELACIÓN A DEPARTAMENTO
  const todosMunicipios = [
    // Para extranjeros
    { departamento: "Otro (Para extranjeros)", codigo: "00", nombre: "Otro (Para extranjeros)" },
    
    // AHUACHAPÁN
    { departamento: "AHUACHAPAN", codigo: "13", nombre: "AHUACHAPAN NORTE" },
    { departamento: "AHUACHAPAN", codigo: "14", nombre: "AHUACHAPAN CENTRO" },
    { departamento: "AHUACHAPAN", codigo: "15", nombre: "AHUACHAPAN SUR" },
    
    // SANTA ANA
    { departamento: "SANTA ANA", codigo: "16", nombre: "SANTA ANA NORTE" },
    { departamento: "SANTA ANA", codigo: "17", nombre: "SANTA ANA CENTRO" },
    { departamento: "SANTA ANA", codigo: "18", nombre: "SANTA ANA ESTE" },
    { departamento: "SANTA ANA", codigo: "19", nombre: "SANTA ANA OESTE" },
    
    // SONSONATE
    { departamento: "SONSONATE", codigo: "20", nombre: "SONSONATE NORTE" },
    { departamento: "SONSONATE", codigo: "21", nombre: "SONSONATE CENTRO" },
    { departamento: "SONSONATE", codigo: "22", nombre: "SONSONATE ESTE" },
    { departamento: "SONSONATE", codigo: "23", nombre: "SONSONATE OESTE" },
    
    // CHALATENANGO
    { departamento: "CHALATENANGO", codigo: "34", nombre: "CHALATENANGO NORTE" },
    { departamento: "CHALATENANGO", codigo: "35", nombre: "CHALATENANGO CENTRO" },
    { departamento: "CHALATENANGO", codigo: "36", nombre: "CHALATENANGO SUR" },
    
    // LA LIBERTAD
    { departamento: "LA LIBERTAD", codigo: "24", nombre: "LA LIBERTAD NORTE" },
    { departamento: "LA LIBERTAD", codigo: "25", nombre: "LA LIBERTAD CENTRO" },
    { departamento: "LA LIBERTAD", codigo: "26", nombre: "LA LIBERTAD OESTE" },
    { departamento: "LA LIBERTAD", codigo: "27", nombre: "LA LIBERTAD ESTE" },
    { departamento: "LA LIBERTAD", codigo: "28", nombre: "LA LIBERTAD COSTA" },
    { departamento: "LA LIBERTAD", codigo: "29", nombre: "LA LIBERTAD SUR" },
    
    // SAN SALVADOR
    { departamento: "SAN SALVADOR", codigo: "30", nombre: "SAN SALVADOR NORTE" },
    { departamento: "SAN SALVADOR", codigo: "31", nombre: "SAN SALVADOR OESTE" },
    { departamento: "SAN SALVADOR", codigo: "32", nombre: "SAN SALVADOR ESTE" },
    { departamento: "SAN SALVADOR", codigo: "33", nombre: "SAN SALVADOR CENTRO" },
    { departamento: "SAN SALVADOR", codigo: "37", nombre: "SAN SALVADOR SUR" },
    
    // CUSCATLÁN
    { departamento: "CUSCATLAN", codigo: "38", nombre: "CUSCATLAN NORTE" },
    { departamento: "CUSCATLAN", codigo: "39", nombre: "CUSCATLAN SUR" },
    
    // LA PAZ
    { departamento: "LA PAZ", codigo: "40", nombre: "LA PAZ OESTE" },
    { departamento: "LA PAZ", codigo: "41", nombre: "LA PAZ CENTRO" },
    { departamento: "LA PAZ", codigo: "42", nombre: "LA PAZ ESTE" },
    
    // CABAÑAS
    { departamento: "CABAÑAS", codigo: "10", nombre: "CABAÑAS OESTE" },
    { departamento: "CABAÑAS", codigo: "11", nombre: "CABAÑAS ESTE" },
    
    // SAN VICENTE
    { departamento: "SAN VICENTE", codigo: "43", nombre: "SAN VICENTE NORTE" },
    { departamento: "SAN VICENTE", codigo: "44", nombre: "SAN VICENTE SUR" },
    
    // USULUTÁN
    { departamento: "USULUTAN", codigo: "45", nombre: "USULUTAN NORTE" },
    { departamento: "USULUTAN", codigo: "46", nombre: "USULUTAN ESTE" },
    { departamento: "USULUTAN", codigo: "47", nombre: "USULUTAN OESTE" },
    
    // SAN MIGUEL
    { departamento: "SAN MIGUEL", codigo: "48", nombre: "SAN MIGUEL NORTE" },
    { departamento: "SAN MIGUEL", codigo: "49", nombre: "SAN MIGUEL CENTRO" },
    { departamento: "SAN MIGUEL", codigo: "50", nombre: "SAN MIGUEL OESTE" },
    
    // MORAZÁN
    { departamento: "MORAZAN", codigo: "51", nombre: "MORAZAN NORTE" },
    { departamento: "MORAZAN", codigo: "52", nombre: "MORAZAN SUR" },
    
    // LA UNIÓN
    { departamento: "LA UNION", codigo: "53", nombre: "LA UNION NORTE" },
    { departamento: "LA UNION", codigo: "54", nombre: "LA UNION SUR" },
  ];

  // ✅ FILTRAR MUNICIPIOS según departamento seleccionado (por NOMBRE)
  const municipiosFiltrados = useMemo(() => {
    if (!form.departamento) {
      return [];
    }
    return todosMunicipios.filter(m => m.departamento === form.departamento);
  }, [form.departamento]);

  // 🔄 Cargar datos si es edición
  useEffect(() => {
    if (editingSupplier) {
      setForm({
        nombre: editingSupplier.nombre || "",
        nombre_comercial: editingSupplier.nombre_comercial || "",
        contacto: editingSupplier.contacto || "",
        telefono: editingSupplier.telefono || "",
        email: editingSupplier.email || "",
        direccion: editingSupplier.direccion || "",
        departamento: editingSupplier.departamento || "",
        municipio: editingSupplier.municipio || "",
        nit: editingSupplier.nit || "",
        nrc: editingSupplier.nrc || "",
        giro: editingSupplier.giro || "",
      });
    }
  }, [editingSupplier]);

  // 🎯 Foco automático en Nombre
  useEffect(() => {
    nombreRef.current?.focus();
  }, []);

  // 🧠 Manejo de inputs
  const handleChange = (e) => {
    const { name, value } = e.target;
    
    // Si cambia el departamento, limpiar municipio
    if (name === "departamento") {
      setForm({
        ...form,
        departamento: value,
        municipio: "", // Resetear municipio
      });
    } else {
      setForm({
        ...form,
        [name]: value,
      });
    }
  };

  // 💾 Guardar proveedor
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (editingSupplier) {
        await api.put(`/suppliers/${editingSupplier.id}`, form);
        Swal.fire(
          "Actualizado",
          "Proveedor actualizado correctamente",
          "success"
        );
      } else {
        await api.post("/suppliers", form);
        Swal.fire("Guardado", "Proveedor creado correctamente", "success");
      }

      onSaved();
    } catch (error) {
      if (error.response?.status === 422) {
        const errors = error.response.data.errors;
        const firstError = Object.values(errors)[0][0];
        Swal.fire("Error de validación", firstError, "error");
      } else {
        Swal.fire("Error", "Ocurrió un error al guardar el proveedor", "error");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card" style={{ marginBottom: "24px" }}>
      <div className="card-header">
        <div className="d-flex align-items-center gap-2">
          <Truck size={24} color="#667eea" />
          <h2 className="card-title" style={{ fontSize: "20px" }}>
            {editingSupplier ? "Editar Proveedor" : "Nuevo Proveedor"}
          </h2>
        </div>
      </div>

      <div className="card-body">
        <form onSubmit={handleSubmit}>
          {/* INFORMACIÓN GENERAL */}
          <h4
            style={{
              fontSize: "16px",
              fontWeight: 600,
              marginBottom: "16px",
              color: "#2d3748",
            }}
          >
            <Building2 size={18} style={{ display: "inline", marginRight: "8px" }} />
            Información General
          </h4>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
              gap: "16px",
              marginBottom: "24px",
            }}
          >
            <div className="form-group">
              <label className="form-label">Nombre *</label>
              <input
                type="text"
                name="nombre"
                className="form-control"
                placeholder="Nombre del proveedor"
                value={form.nombre}
                onChange={handleChange}
                ref={nombreRef}
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">Nombre Comercial</label>
              <input
                type="text"
                name="nombre_comercial"
                className="form-control"
                placeholder="Nombre comercial"
                value={form.nombre_comercial}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label className="form-label">Giro o Actividad</label>
              <input
                type="text"
                name="giro"
                className="form-control"
                placeholder="Ej: Distribuidor de alimentos"
                value={form.giro}
                onChange={handleChange}
              />
            </div>
          </div>

          {/* SEPARADOR */}
          <div
            style={{
              borderTop: "2px solid #e2e8f0",
              margin: "24px 0",
            }}
          ></div>

          {/* DATOS FISCALES */}
          <h4
            style={{
              fontSize: "16px",
              fontWeight: 600,
              marginBottom: "16px",
              color: "#2d3748",
            }}
          >
            Datos Fiscales
          </h4>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
              gap: "16px",
              marginBottom: "24px",
            }}
          >
            <div className="form-group">
              <label className="form-label">NIT</label>
              <input
                type="text"
                name="nit"
                className="form-control"
                placeholder="0000-000000-000-0"
                value={form.nit}
                onChange={handleChange}
              />
              <small style={{ color: "#718096", fontSize: "12px" }}>
                Puede incluir guiones (se guardará sin guiones)
              </small>
            </div>

            <div className="form-group">
              <label className="form-label">NRC</label>
              <input
                type="text"
                name="nrc"
                className="form-control"
                placeholder="000000-0"
                value={form.nrc}
                onChange={handleChange}
              />
              <small style={{ color: "#718096", fontSize: "12px" }}>
                Puede incluir guión (se guardará sin guión)
              </small>
            </div>
          </div>

          {/* SEPARADOR */}
          <div
            style={{
              borderTop: "2px solid #e2e8f0",
              margin: "24px 0",
            }}
          ></div>

          {/* INFORMACIÓN DE CONTACTO */}
          <h4
            style={{
              fontSize: "16px",
              fontWeight: 600,
              marginBottom: "16px",
              color: "#2d3748",
            }}
          >
            <User size={18} style={{ display: "inline", marginRight: "8px" }} />
            Información de Contacto
          </h4>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
              gap: "16px",
              marginBottom: "24px",
            }}
          >
            <div className="form-group">
              <label className="form-label">
                <User size={14} style={{ display: "inline", marginRight: "4px" }} />
                Persona de Contacto
              </label>
              <input
                type="text"
                name="contacto"
                className="form-control"
                placeholder="Nombre del contacto"
                value={form.contacto}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label className="form-label">
                <Phone size={14} style={{ display: "inline", marginRight: "4px" }} />
                Teléfono
              </label>
              <input
                type="text"
                name="telefono"
                className="form-control"
                placeholder="0000-0000"
                value={form.telefono}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label className="form-label">
                <Mail size={14} style={{ display: "inline", marginRight: "4px" }} />
                Correo Electrónico
              </label>
              <input
                type="email"
                name="email"
                className="form-control"
                placeholder="correo@ejemplo.com"
                value={form.email}
                onChange={handleChange}
              />
            </div>
          </div>

          {/* SEPARADOR */}
          <div
            style={{
              borderTop: "2px solid #e2e8f0",
              margin: "24px 0",
            }}
          ></div>

          {/* DIRECCIÓN */}
          <h4
            style={{
              fontSize: "16px",
              fontWeight: 600,
              marginBottom: "16px",
              color: "#2d3748",
            }}
          >
            Dirección
          </h4>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "2fr 1fr 1fr",
              gap: "16px",
              marginBottom: "24px",
            }}
          >
            <div className="form-group">
              <label className="form-label">Dirección Completa</label>
              <input
                type="text"
                name="direccion"
                className="form-control"
                placeholder="Dirección del proveedor"
                value={form.direccion}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label className="form-label">Departamento</label>
              <select
                name="departamento"
                className="form-control"
                value={form.departamento}
                onChange={handleChange}
              >
                <option value="">Seleccione...</option>
                {departamentos.map((depto) => (
                  <option key={depto.codigo} value={depto.nombre}>
                    {depto.nombre}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label className="form-label">Municipio</label>
              <select
                name="municipio"
                className="form-control"
                value={form.municipio}
                onChange={handleChange}
                disabled={!form.departamento}
              >
                <option value="">
                  {form.departamento ? "Seleccione..." : "Primero seleccione departamento"}
                </option>
                {municipiosFiltrados.map((muni) => (
                  <option key={muni.codigo} value={muni.nombre}>
                    {muni.nombre}
                  </option>
                ))}
              </select>
              {form.departamento && municipiosFiltrados.length === 0 && (
                <small style={{ color: "#e53e3e", fontSize: "12px", display: "block", marginTop: "4px" }}>
                  ⚠️ No hay municipios disponibles para este departamento
                </small>
              )}
            </div>
          </div>

          {/* BOTONES */}
          <div className="d-flex gap-2" style={{ marginTop: "32px" }}>
            <button
              type="submit"
              className="btn btn-success"
              disabled={loading}
            >
              <Save size={18} />
              {loading
                ? "Guardando..."
                : editingSupplier
                ? "Actualizar Proveedor"
                : "Guardar Proveedor"}
            </button>

            {onCancel && (
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onCancel}
                disabled={loading}
              >
                <X size={18} />
                Cancelar
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
}